









import { Component, Vue } from "vue-property-decorator";
import $api from "../api";

@Component
export default class BackToTop extends Vue {
  private scrollTop: number = 0;
  private toTopShow: boolean = false;

  mounted() {
    this.$nextTick(function() {
      window.addEventListener("scroll", this.handleScroll, true);
    });
  }

  destroyed() {
    window.addEventListener("scroll", this.handleScroll, true);
  }

  handleScroll() {
    let dom = document.documentElement;
    this.scrollTop = dom.scrollTop;
    if (this.scrollTop > 300) {
      this.toTopShow = true;
    } else {
      this.toTopShow = false;
    }
  }

  scrollToTop() {
    let timer: any = null;
    let _this = this;
    cancelAnimationFrame(timer);
    timer = requestAnimationFrame(function fn() {
      if (_this.scrollTop > 5000) {
        _this.scrollTop -= 500;
        document.documentElement.scrollTop = _this.scrollTop;
        timer = requestAnimationFrame(fn);
      } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
        _this.scrollTop -= 250;
        document.documentElement.scrollTop = _this.scrollTop;
        timer = requestAnimationFrame(fn);
      } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
        _this.scrollTop -= 50;
        document.documentElement.scrollTop = _this.scrollTop;
        timer = requestAnimationFrame(fn);
      } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
        _this.scrollTop -= 50;
        document.documentElement.scrollTop = _this.scrollTop;
        timer = requestAnimationFrame(fn);
      } else if (_this.scrollTop > 0 && _this.scrollTop <= 50) {
        _this.scrollTop -= 50;
        document.documentElement.scrollTop = _this.scrollTop;
        timer = requestAnimationFrame(fn);
      } else {
        cancelAnimationFrame(timer);
        _this.toTopShow = false;
      }
    });
  }
}
